import React from 'react';
import Wrapper from './Wrapper';

const OpenBook = Wrapper(props => (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6111 4.60168V24.6576"
      stroke="#343A40"
      strokeWidth="2.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5696 3.61147C17.4304 3.80362 16.3115 4.10055 15.2269 4.49846C14.829 4.64085 14.3941 4.64085 13.9962 4.49846C10.5136 3.1335 6.65868 3.05309 3.1221 4.27161C2.36408 4.51211 1.84949 5.2163 1.8506 6.01156V22.2734C1.84838 22.8379 2.10778 23.3715 2.55304 23.7184C2.99829 24.0653 3.57915 24.1864 4.12592 24.0463C7.3826 23.1344 10.8482 23.3128 13.994 24.5544C14.3917 24.6977 14.8269 24.6977 15.2246 24.5544C18.3704 23.3126 21.836 23.1341 25.0927 24.0463C25.6386 24.1857 26.2184 24.065 26.6633 23.7192C27.1083 23.3735 27.3684 22.8414 27.368 22.278V6.01156C27.3676 5.21889 26.855 4.51735 26.0999 4.27614C25.2226 3.9942 24.3261 3.77586 23.4174 3.62281"
      stroke="#343A40"
      strokeWidth="2.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5434 12.7729L20.9913 10.2208L18.4392 12.7729V4.26594C18.4392 3.32629 19.2009 2.56455 20.1406 2.56455H21.842C22.7816 2.56455 23.5434 3.32629 23.5434 4.26594V12.7729Z"
      stroke="#343A40"
      strokeWidth="2.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default OpenBook;
